//const { CallTracker } = require("assert");

$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    prevArrow: $('#btn_prev'),
    nextArrow: $('#btn_next'),
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: false,
    arrows: false,
    focusOnSelect: true
});


$('.videos-reviews').slick({
    slidesToScroll: 1,
    dots: false,
    centerPadding: '150px',
    slidesToShow: 5,
    centerMode: true,
    arrows: true,
    prevArrow: $('#video_btn_prev'),
    nextArrow: $('#video_btn_next'),
    responsive: [{
        breakpoint: 1600,
        settings: {
            centerPadding: '150px',
            slidesToShow: 3
        }
    },
        {
            breakpoint: 768,
            settings: {
                centerPadding: '45px',
                slidesToShow: 3
            }
        },
        {
            breakpoint: 480,
            settings: {
                centerPadding: '80px',
                slidesToShow: 1
            }
        }
    ]
    // focusOnSelect: true
});


//
//
// Shopify formatMoney
//
//

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "€{{amount}}";
Shopify.formatMoney = function (cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};

//
//
// End Shopify formatMoney
//
//

let Cloudpillo = {
    updateQty(line, qty) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({quantity: qty, line: line})
        }).then(response => response.json())
            .then(data => {
                window.dispatchEvent(new Event('cart-updated'))
                document.getElementById('cart__drawer_items').innerHTML = 'No products';
            })
    }
}

window.Cloudpillo = Cloudpillo

function QtyBtnPlus() {
    var varianId = this.getAttribute('data-id');
    CartJS.updateItemById(varianId, CartJS.cart.item_count + 1);
}

function QtyBtnMinus() {
    var varianId = this.getAttribute('data-id');
    CartJS.updateItemById(varianId, CartJS.cart.item_count + 1);
}

// //  On click ADC button
// document.getElementById('checkout').addEventListener('click', function(e) {
//   //e.preventDefault();
//   //var varianId = this.getAttribute('data-id');
//   //addCloudpilloTOCart(varianId);
//   // Open cart drawer
//   document.querySelector('.site-header__cart').click();
// });


function addCloudpilloTOCart(varianId) {
    CartJS.addItem(varianId, 1, {
        //"size": "XL"
    }, {
        "success": function (data, textStatus, jqXHR) {
            console.log(data);

            if (data.quantity > 0) {
                // Count num of all num cart items
                $(document).on('cart.requestComplete', function (event, cart) {
                    // Drawer items
                    document.getElementById('cart__drawer_items').innerHTML = '<div class="product__item"><img width="70" height="70" loading="lazy" src="' + cart.items[0].featured_image.url + '"><div class="product__info"><h5>' + cart.items[0].product_title + '</h5><p class="item__price">' + cart.items[0].quantity + ' x ' + Shopify.formatMoney(cart.items[0].price) + ' </p></div><span id="removeItem" class="remove"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>close</title><g fill="none"><path d="M6.225 4.811a1 1 0 0 0-1.414 1.414L10.586 12 4.81 17.775a1 1 0 1 0 1.414 1.414L12 13.414l5.775 5.775a1 1 0 0 0 1.414-1.414L13.414 12l5.775-5.775a1 1 0 0 0-1.414-1.414L12 10.586 6.225 4.81z" fill="#333333"></path></g></svg></span></div>';
                    // Drawer footer
                    document.getElementById('cartTotal').innerHTML = '<div class="total__wrap"><div class="label">Verzending</div><div class="label">Gratis</div><h4 class="total">Total:</h4><h4 class="total"  id="cart__total_price">' + Shopify.formatMoney(CartJS.cart.total_price) + '</h4></div>';
                    document.querySelectorAll('.cart__number__count').forEach(count => {
                        count.innerHTML = cart.item_count;
                    });
                });

            } else {
                document.getElementById('cart__drawer_items').innerHTML = '<p>Cart is emprty</p>';
            }

            // Open cart drawer
            document.querySelector('.site-header__cart').click();

        },
        "error": function (jqXHR, textStatus, errorThrown) {
            alert('Error: ' + errorThrown + '!');
        }
    });
}


// $(document).on('cart.requestComplete', function(event, cart) {
// var removeButton = document.getElementById('removeItem');
//       if ( removeButton ) {
//         removeButton.addEventListener('click', function(e) {
//           console.log('clear cart');
//           CartJS.clear();
//           document.getElementById('cartTotal').innerHTML = '';
//           document.getElementById('cart__drawer_items').innerHTML = '';
//             // Count num of all num cart items
//             document.querySelectorAll('.cart__number__count').forEach(count => {
//               count.innerHTML = CartJS.cart.items[0].quantity;
//             });
//         });
//       }
//     });


// function get_cart_items() {
//   fetch('/cart.js')
//     .then((resp) => resp.json())
//     .then((data) => {

//       //CartJS.addItem(41900045074598);
//       if (data.items.length > 0) {
//         data.items.forEach(function (product, index) {
//           if (product.quantity > 0) {
//             // document.getElementById('cart__total_price').innerHTML = Shopify.formatMoney(product.final_line_price);
//           }
//           // Drawer items
//           document.getElementById('cart__drawer_items').innerHTML = '<div class="product__item"><img width="70" height="70" src="' + CartJS.cart.items[0].image + '"><div class="product__info"><h5>' + CartJS.cart.items[0].product_title + '<span id="removeItem" class="remove">x</span></h5><p class="item__price">' + product.quantity + ' x ' + Shopify.formatMoney(product.price) + ' </p></div></div>';

//           // Drawer footer
//           document.getElementById('cartTotal').innerHTML = '<div class="total__wrap"><div class="label">Verzending</div><div class="label">Gratis</div><h4 class="total">Total:</h4><h4 class="total"  id="cart__total_price">' + Shopify.formatMoney(CartJS.cart.total_price) + '</h4></div>';
//           //document.getElementById('cart__total_price').innerHTML =  Shopify.formatMoney(CartJS.cart.total_price);


//           // document.getElementById('removeItem').addEventListener('click', function(e) {
//           //   //CartJS.clear();
//           //   var newQuantity = 0;
//           //   CartJS.updateItem(1, newQuantity);
//           // });

//           // coutn logic
//           // if (product.quantity == 2) {
//           //   // document.getElementById('cart__total_price').innerHTML = Shopify.formatMoney((product.final_line_price) - 14.0);
//           //   document.getElementById('cart__total_price').innerHTML = '€125.9';
//           // }

//           // Add quantity num to cart icon num
//           document.querySelectorAll('.cart__number__count').forEach(count => {
//             count.innerHTML = product.quantity;
//           });

//         });
//       } else {
//         document.getElementById('cart__drawer_items').innerHTML = '<p>Cart is empty</p>';
//         document.getElementById('cart__checkout_btn').setAttribute('disabled', 'disabled');
//         document.getElementById('cart__checkout_btn').style.pointerEvents = 'none';
//       }

//       // console.log(Shopify);
//       //console.log('test');

//       // document.getElementById('cart__total_price').innerHTML = theme.Currency.formatMoney(data.original_total_price, theme.moneyFormat);
//       // document.getElementById('cart__total_price').innerHTML = Shopify.formatMoney(product.final_line_price, "€{{amount}}");
//       // document.getElementById('cart__total_price').innerHTML = Shopify.formatMoney(final_line_price, "€{{amount}}");

//     });
// }


// Header Quantity Selector //

$(document).ready(function () {
    $("#quantityoption1").click(function () {
        $(this).addClass("selected"), $("#quantityoption2").removeClass("selected"), $("#quantityoption3").removeClass("selected");
    }),
        $("#quantityoption2").click(function () {
            $(this).addClass("selected"), $("#quantityoption1").removeClass("selected"), $("#quantityoption3").removeClass("selected");
        }),
        $("#quantityoption3").click(function () {
            $(this).addClass("selected"), $("#quantityoption1").removeClass("selected"), $("#quantityoption2").removeClass("selected");
        });
});


let variant = 41900045074598;
quantity = 1;
const option1 = document.querySelector("#quantityoption1"),
    option2 = document.querySelector("#quantityoption2"),
    option3 = document.querySelector("#quantityoption3"),
    prijs = document.querySelector("#productPrijs"),
    prijsm = document.querySelector("#productPrijs2"),
    prisAdc = document.querySelector("#price-in-adc"),
    prijsmobile = document.querySelector("#productPrijsMobile"),
    quantitytext = document.querySelector("#quantityLabel");
stickyAdcPrice = document.querySelector('#stickyPrice');
quantitytextmobile = document.querySelector("#quantityLabelMobile");
quantitySelector = document.querySelector("#quantity");

function addItemToCart() {
    (data = {
        id: variant,
        quantity: quantity
    }),
        jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: () => {
                //console.log(data);
                // window.location.href = "/cart";
                // window.SLIDECART_UPDATE();
                // openSlide();
                //quantity++;
                //get_cart_items();
                //document.querySelector('.site-header__cart').click();
                console.log('Success it a live!!');
            },
        });
}

(quantitytext.innerHTML = "Pris per styck"),
    option1.addEventListener("click", () => {
        //(quantity = 1),
        quantitySelector.value = '1';
        (variant = 41900045074598),
            (prijs.innerHTML = "750 kr"),
            (prijsm.innerHTML = "750 kr"),
            (prisAdc.innerHTML = "750 kr"),
            (stickyAdcPrice.innerHTML = "750 kr"),
            // (prijsmobile.innerHTML = "750 kr"),
            (quantitytext.innerHTML = "Pris per styck");
        // (quantitytextmobile.innerHTML = "Pris per styck");
    }),
    option2.addEventListener("click", () => {
        quantitySelector.value = '2';
        (quantity = 2),
            (variant = 41900045074598),
            (prijs.innerHTML = "675 kr"),
            (prisAdc.innerHTML = "675 kr"),
            (prijsm.innerHTML = "675 kr"),
            (stickyAdcPrice.innerHTML = "675 kr"),
            // (prijsmobile.innerHTML = "675 kr"),
            (quantitytext.innerHTML = "Pris per styck <span class=\"discount-highlight\">(med rabatt)</span>");
        // (quantitytextmobile.innerHTML = "Pris per styck <span class=\"discount-highlight\">(med rabatt)</span>");
    }),
    option3.addEventListener("click", () => {
        quantitySelector.value = '4';
        (quantity = 4),
            (variant = 41900045074598),
            (prijs.innerHTML = "600 kr"),
            (prisAdc.innerHTML = "600 kr"),
            (prijsm.innerHTML = "600 kr"),
            (stickyAdcPrice.innerHTML = "600 kr"),
            // (prijsmobile.innerHTML = "600 kr"),
            (quantitytext.innerHTML = "Pris per styck <span class=\"discount-highlight\">(med rabatt)</span>");
        // (quantitytextmobile.innerHTML = "Pris per styck <span class=\"discount-highlight\">(med rabatt)</span>");
    });


// Bottom Quantity Selector //
let variant_bottom = 41900045074598,
    quantity_bottom = 1;
const option1_bottom = document.querySelector("#quantityoption1_bottom"),
    option2_bottom = document.querySelector("#quantityoption2_bottom"),
    option3_bottom = document.querySelector("#quantityoption3_bottom"),
    prijsmobile_bottom = document.querySelector("#productPrijsMobile_bottom"),
    prijsmobile_bottomm = document.querySelector("#productPrijsMobile_bottom2"),
    quantitytextmobile_bottom = document.querySelector("#quantityLabelMobile_bottom"),
    quantitytextmobile_bottomm = document.querySelector("#quantityLabelMobile_bottom2");
quantitySelectorBottom = document.querySelector("#quantity_bottom");

function addItemToCartBottom() {
    (data = {
        id: variant_bottom,
        quantity: quantity_bottom
    }),
        jQuery.ajax({
            type: "POST",
            url: "/cart/clear.js",
            data: "",
            dataType: "json",
            success: function () {
                jQuery.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    data: data,
                    dataType: "json",
                    success: () => {
                        //window.location.href = "/cart/checkout";
                        //window.SLIDECART_UPDATE();
                        //openSlide();
                    },
                });
            },
        });
}


$(document).ready(function () {
    $("#quantityoption1_bottom").click(function () {
        quantitySelectorBottom.value = '1';
        $(this).addClass("selected"),
            $("#quantityoption2_bottom").removeClass("selected"),
            $("#quantityoption3_bottom").removeClass("selected"),
            (quantity_bottom = 1),
            (variant_bottom = 41900045074598),
            (prijsmobile_bottom.innerHTML = "750 kr"),
            (prijsmobile_bottomm.innerHTML = "750 kr"),
            (stickyAdcPrice.innerHTML = "750 kr"),
            (quantitytextmobile_bottom.innerHTML = "Pris per styck"),
            (quantitytextmobile_bottomm.innerHTML = "Pris per styck");
    }),
        $("#quantityoption2_bottom").click(function () {
            quantitySelectorBottom.value = '2';
            $(this).addClass("selected"),
                $("#quantityoption1_bottom").removeClass("selected"),
                $("#quantityoption3_bottom").removeClass("selected"),
                (quantity_bottom = 2),
                (variant_bottom = 42497170374822),
                (prijsmobile_bottom.innerHTML = "675 kr"),
                (prijsmobile_bottomm.innerHTML = "675 kr"),
                (stickyAdcPrice.innerHTML = "675 kr"),
                (quantitytextmobile_bottom.innerHTML = "Pris per styck <span class=\"discount-highlight\">(med rabatt)</span>"),
                (quantitytextmobile_bottomm.innerHTML = "Pris per styck <span class=\"discount-highlight\">(med rabatt)</span>");
        }),
        $("#quantityoption3_bottom").click(function () {
            quantitySelectorBottom.value = '4';
            $(this).addClass("selected"),
                $("#quantityoption1_bottom").removeClass("selected"),
                $("#quantityoption2_bottom").removeClass("selected"),
                (quantity_bottom = 4),
                (variant_bottom = 42497170571430),
                (prijsmobile_bottom.innerHTML = "600 kr"),
                (prijsmobile_bottomm.innerHTML = "600 kr"),
                (stickyAdcPrice.innerHTML = "600 kr"),
                (quantitytextmobile_bottom.innerHTML = "Pris per styck <span class=\"discount-highlight\">(med rabatt)</span>"),
                (quantitytextmobile_bottomm.innerHTML = "Pris per styck <span class=\"discount-highlight\">(med rabatt)</span>");
        });
});

